import type { PublicProductOption } from "@/types/store";
import PublicItemGallery from "./PublicItemGallery";

export function OptionImage({ option }: { option: PublicProductOption }) {
  if (!option.image_url) return null;
  return (
    <PublicItemGallery
      images={[option.image_url]}
      itemName={option.name}
      description={option.description}
      previewOnly
    />
  );
}

export default function OptionContent({
  option,
}: {
  option: PublicProductOption;
}) {
  return (
    <span className="flex min-w-0 flex-1 items-center gap-3">
      <span className="min-w-0 flex-1 break-words">
        <span className="block text-sm font-bold text-slate-800">
          {option.name}
        </span>
        {option.description && (
          <span className="mt-1 block whitespace-pre-line text-xs font-normal text-slate-500">
            {option.description}
          </span>
        )}
      </span>
    </span>
  );
}
